import AccountService from "./AccountService";
import EventBus from "./EventBus";
import ModuleLoadService from "./ModuleLoadService";

const eventBus = new EventBus();
export default {
  AccountService: new AccountService(eventBus),
  EventBus: eventBus,
  ModuleLoadService: new ModuleLoadService(),
};
